// extracted by mini-css-extract-plugin
module.exports = {"candidateContent":"_3ZJBSBbw","dashboardTitleContainer":"_3eGFJufn","candidateHeader":"_1F1Vxd61","candidateHeaderLeft":"jg-G5KCF","candidateHeaderBold":"_2LPaO9mn","candidateHeaderText":"_1BzQHY5G","candidateHeaderTextIn":"D4W_nSyJ","actionsContent":"_3GrdyVQN","nameHeader":"_3gvgsRkh","candActionHeader":"_3_s6rD6i","lastActivityContent":"_1O8cUROF","lastActivityHeader":"_2fopUrbG","okay":"_1hVI0_uq","warning":"_3Pwfj-tE","notice":"_2AYHfSks"};
    if(module.hot) {
      // 1754514957573
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  